/**
 * This file contains authentication parameters. Contents of this file
 * is roughly the same across other MSAL.js libraries. These parameters
 * are used to initialize Angular and MSAL Angular configurations in
 * in app.module.ts file.
 */

import { ProtectedResourceScopes } from '@azure/msal-angular';
import { LogLevel, Configuration, BrowserCacheLocation } from '@azure/msal-browser';

export const pandaApiScope = ["api://500e7b4a-161a-4106-9609-4a489b9341b2/panda-api"];

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig: Configuration = {
    auth: {
        clientId: 'f2f15424-5d14-4c04-9464-d245afc799b7', // This is the ONLY mandatory field that you need to supply.
        authority: 'https://pandaeleventwelve.ciamlogin.com/pandaeleventwelve.onmicrosoft.com', // replace "Enter_the_Tenant_Name_Here" with your tenant name
        knownAuthorities: ["pandaeleventwelve.ciamlogin.com"], // replace "Enter_the_Tenant_Name_Here" with your tenant name
        redirectUri: '/', // Points to window.location.origin by default. You must register this URI on Azure portal/App Registration.
        postLogoutRedirectUri: '/', // Points to window.location.origin by default.
    },
    cache: {
        cacheLocation: BrowserCacheLocation.LocalStorage, // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    },
    system: {
        loggerOptions: {
            loggerCallback(logLevel: LogLevel, message: string) {
                console.log(message);
            },
            logLevel: LogLevel.Error,
            piiLoggingEnabled: false,
        },
    },
};

export const protectedResourceMap: Map<string, Array<string | ProtectedResourceScopes> | null> =
    new Map<string, Array<string | ProtectedResourceScopes> | null>([
        ["http://localhost:5001/v1/app/settings", null],
        ["http://localhost:5001/v1/*", pandaApiScope],

        ["https://pandaapi-test.equipforequality.org/v1/app/settings", null],
        ["https://pandaapi-test.equipforequality.org/v1/*", pandaApiScope],

        ["https://pandaapi.equipforequality.org/v1/app/settings", null],
        ["https://pandaapi.equipforequality.org/v1/*", pandaApiScope],
    ]);

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: pandaApiScope
};
